import { gql, QueryHookOptions, QueryResult, useMutation, useQuery } from '@apollo/client';
import {
	StakingEnrollmentsScreen_CancelEnrollment,
	StakingEnrollmentsScreen_CancelEnrollmentVariables,
	StakingEnrollmentsScreen_GetStakingEnrollments,
	StakingEnrollmentsScreen_GetStakingEnrollmentsVariables,
} from '@app/codegen';

export const STAKING_ENROLLMENTS_SCREEN_GET_STAKING_ENROLLMENTS = gql`
	query StakingEnrollmentsScreen_GetStakingEnrollments(
		$where: StakingEnrollmentFilterInput
		$after: String
	) {
		stakingEnrollments(where: $where, order: { createdAt: DESC }, first: 25, after: $after) {
			pageInfo {
				startCursor
				endCursor
				hasNextPage
				hasPreviousPage
			}
			nodes {
				id
				createdAt
				completedAt
				principle
				status
				reward
				stakedAt
				unstakedAt
				account {
					accountNumber
				}
				currency {
					ticker
				}
			}
			totalCount
		}
	}
`;

export const STAKING_ENROLLMENTS_SCREEN_CANCEL_ENROLLMENT = gql`
	mutation StakingEnrollmentsScreen_CancelEnrollment($stakingEnrollmentId: Int!) {
		cancelStakingEnrollment(input: { stakingEnrollmentId: $stakingEnrollmentId }) {
			success
			errorMessage
		}
	}
`;

export function useCancelEnrollmentMutation() {
	return useMutation<
		StakingEnrollmentsScreen_CancelEnrollment,
		StakingEnrollmentsScreen_CancelEnrollmentVariables
	>(STAKING_ENROLLMENTS_SCREEN_CANCEL_ENROLLMENT, {
		refetchQueries: [{ query: STAKING_ENROLLMENTS_SCREEN_GET_STAKING_ENROLLMENTS }],
	});
}

export type GetStakingEnrollmentsQueryProps = QueryHookOptions<
	StakingEnrollmentsScreen_GetStakingEnrollments,
	StakingEnrollmentsScreen_GetStakingEnrollmentsVariables
>;

export type StakingEnrollmentsQueryResult = QueryResult<
	StakingEnrollmentsScreen_GetStakingEnrollments,
	StakingEnrollmentsScreen_GetStakingEnrollmentsVariables
>;

export function useStakingEnrollmentsScreen_GetStakingEnrollmentsQuery(
	props: GetStakingEnrollmentsQueryProps
): StakingEnrollmentsQueryResult {
	return useQuery<
		StakingEnrollmentsScreen_GetStakingEnrollments,
		StakingEnrollmentsScreen_GetStakingEnrollmentsVariables
	>(STAKING_ENROLLMENTS_SCREEN_GET_STAKING_ENROLLMENTS, {
		...props,
		fetchPolicy: 'no-cache',
	});
}
